<template>
    <v-container class="container" fluid>
        <v-card>
            <v-system-bar height="70px" dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Roles </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-system-bar>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    label="Search"
                    append-icon="mdi-magnify"
                    dense
                >
                </v-text-field>
                <v-spacer />
                <v-spacer />

                <v-btn
                    class="ml-1"
                    fab
                    large
                    color="secondary"
                    icon
                    @click="openModal('', 'create')"
                    exact
                >
                    <v-icon large>mdi-plus-circle</v-icon>
                </v-btn>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="roles"
                class="mx-4"
                :search="search"
            >
                <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        class="mx-3"
                        @click="openModal(item, 'update')"
                        >mdi-eye-outline</v-icon
                    >
                    <v-icon
                        v-if="item.name != 'Administrator'"
                        small
                        @click="onDelete(item)"
                        >mdi-delete</v-icon
                    >
                </template>
            </v-data-table>
        </v-card>
        <v-dialog
            v-model="dialog"
            persistent
            class="x dl"
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="pa-8" fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="role.name"
                                    :rules="[v => !!v || 'Name is required']"
                                    label="Name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="4"
                                v-for="(permission, i) in defaultPermissions"
                                v-bind:key="i"
                            >
                                <v-checkbox
                                    v-model="permissions"
                                    :value="permission"
                                    :label="`${permission}`"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row justify="end" class="px-5">
                            <v-btn
                                class="mx-5"
                                small
                                @click="dialog = false"
                                color="secondary"
                                >Cancel</v-btn
                            >
                            <v-btn small @click="save(type)" color="secondary"
                                >Save</v-btn
                            >
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>
<script>
import axios from 'axios';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
export default {
    components: {
        ConfirmDialogue
    },
    data: function() {
        return {
            roles: [],
            permissions: [],
            defaultPermissions: [],
            role: [],
            type: '',
            search: '',
            dialog: false,
            headers: [
                { text: 'ID', value: 'id' },
                {
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'Created at',
                    value: 'created_at'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false
                }
            ]
        };
    },
    mounted() {
        this.loadRoles();
        this.loadPermission();
    },
    methods: {
        loadRoles: function() {
            this.$store.state.isLoading = true;
            axios
                .get('/role')
                .then(response => {
                    this.roles = response.data;
                    for (let i = 0; i < this.roles.length; i++) {
                        if (this.roles[i].created_at != null)
                            this.roles[i].created_at = new Date(
                                this.roles[i].created_at
                            ).toLocaleString();
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        loadPermission: function() {
            this.$store.state.isLoading = true;
            axios
                .get('/permission')
                .then(response => {
                    this.defaultPermissions = response.data;
                    for (var $i = 0; $i < response.data.length; $i++) {
                        this.defaultPermissions[$i] = response.data[$i].name;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        save(type) {
            if (type == 'update') {
                this.update();
            }
            if (type == 'create') {
                this.create();
            }
        },
        create() {
            this.$store.state.isLoading = true;

            var parms = {
                name: this.role.name,
                permissions: this.permissions
            };
            console.log(parms);
            axios
                .post('/role', parms)
                .then(response => {
                    console.log(response);
                    this.dialog = false;
                    this.loadRoles();
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        update() {
            this.$store.state.isLoading = true;

            var parms = {
                name: this.role.name,
                permissions: this.permissions
            };

            axios
                .put('/role/' + this.role.id, parms)
                .then(response => {
                    console.log(response);
                    this.dialog = false;
                    this.loadRoles();
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        async onDelete(item) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Delete role',
                message: 'Do you want to delete' + item.name + ' role?',
                okButton: 'Delete'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteRole(item);
            }
        },
        deleteRole(item) {
            this.$store.state.isLoading = true;

            axios
                .delete('/role/' + item.id)
                .then(response => {
                    console.log(response);

                    this.$store.state.isLoading = false;
                    this.loadRoles();
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Deleted successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        openModal(item, type) {
            this.dialog = true;
            this.permissions = [];
            this.role = [];
            if (item != '') {
                this.role = item;
                for (var $i = 0; $i < item.permissions.length; $i++) {
                    this.permissions[$i] = item.permissions[$i].name;
                }
            }
            this.type = type;
        }
    }
};
</script>
